import CardHeader from "components/CardHeader";
import { Expense } from "models/Expense";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const AccountExpensesCard: React.FC<{ accountId: string }> = ({ accountId }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const [expenses, setExpenses] = useState<Expense[]>([]);
    useEffect(() => { api.getExpenses().then(items => setExpenses(items.filter(expense => expense.account_id === accountId))); }, [accountId]);
    return <Card><CardBody>
        <CardHeader title={t("common.expenses")} icon="mdi-cash-minus" count={expenses.length} />
        {expenses.map(expense => <div className="d-flex justify-content-between align-items-center gap-3 border-bottom py-3" key={expense.id}>
            <div className="min-w-0">
                <Link to={`/expenses/${expense.id}`} className="fw-semibold text-truncate d-block">{expense.name || expense.id}</Link>
                <small className="text-muted">{expense.GetDate().toLocaleDateString(intlLocale)}</small>
            </div>
            <span className="text-end flex-shrink-0">€ {expense.total.toFixed(2)}</span>
        </div>)}
        {!expenses.length && <p className="text-muted mt-3 mb-0">{t("accounts.accountExpensesCard.noExpensesLinkedToThisAccount")}</p>}
    </CardBody></Card>;
};
export default AccountExpensesCard;
